// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lr-0";